import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";


const InvestmentsTable = ({ selectedMember, isLoading, roomId }) => {
  const [isSystmeticInvestmentData, setSystmeticInvestmentData] = useState({});
  console.log("isSystmeticInvestmentData", isSystmeticInvestmentData,selectedMember);
  // SIP card open state
const [openSipIndex, setOpenSipIndex] = useState(null);
const toggleSip = (id) => {
  setOpenSipIndex(prev => (prev === id ? null : id));
};

// STP card open state
const [openStpIndex, setOpenStpIndex] = useState(null);
const toggleStp = (id) => {
  setOpenStpIndex(prev => (prev === id ? null : id));
};

  const fetchSystematicInvestment = async () => {
    try {
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn',
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      const allData =
        selectedMember?.pan && selectedMember?.client_name
          ? {
              panval: `${selectedMember.pan}_${selectedMember.client_name}`,
              clientid: roomId,
            }
          : { panval: "all_Household", clientid: roomId };
            // CADPD5515L_Household
      const response = await api.post(
        `advisor/getSystmeticInvestments`,
        allData
      );
// console.log('response',response);

      setSystmeticInvestmentData(response.data);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      Swal.fire({
        title:"Error",
        text:"Failed to load data. Please try again later.",
        icon:"error",
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn',
        },
      }
      );
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchSystematicInvestment();
  }, [selectedMember, roomId]);

  const sipStop = (
    clientId,
    siplistId,
    folioNo,
    productCode,
    fundName,
    sipAmount,
    ecsDate,
    xsipRegNo,
    mandateId
  ) => {
    // console.log(
    //   "sipStop",
    //   clientId,
    //   siplistId,
    //   folioNo,
    //   productCode,
    //   fundName,
    //   sipAmount,
    //   ecsDate,
    //   xsipRegNo,
    //   mandateId
    // );

    // Validate required fields
    if (
      clientId 
    //   &&
    //   siplistId &&
    //   productCode &&
    //   fundName &&
    //   sipAmount &&
    //   ecsDate &&
    //   xsipRegNo &&
    //   mandateId
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "Please confirm your action.",
        input: "textarea",
        inputPlaceholder: "Enter Remarks..",
        inputAttributes: {
          rows: 2,
          maxlength: 200,
        },
        showCancelButton: true,
        confirmButtonText: "Yes, Proceed",
        cancelButtonText: "No",
        customClass: {
        confirmButton: "swal-confirm-btn",
          input: "swal-input-font-size",
        },
        preConfirm: (remark) => {
          if (!remark.trim()) {
            Swal.showValidationMessage("Remarks cannot be empty.");
            return false;
          }
          if (remark.length > 200) {
            Swal.showValidationMessage(
              "Remarks should not exceed 200 characters."
            );
            return false;
          }
          return remark;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          executeSipStopForm(
            clientId,
            siplistId,
            folioNo,
            productCode,
            fundName,
            sipAmount,
            ecsDate,
            xsipRegNo,
            mandateId,
            result.value
          );
          Swal.fire(
            "Success!",
            "SIP stop request has been submitted.",
            "success"
          );
        }
      });
    } else {
      Swal.fire(
        "Error",
        "Something went wrong! Please check the input fields.",
        "error"
      );
    }
  };

  async function executeSipStopForm(
    clientId,
    siplistId,
    folioNo,
    productCode,
    fundName,
    sipAmount,
    ecsDate,
    xsipRegNo,
    mandateId,
    remark
  ) {
    try {
      Swal.fire({
        text: "Processing your request...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const response = await api.post("advisor/Newgoalcontroller/sipStopNew", {
        clientId,
        siplistId,
        folioNo,
        productCode,
        fundName,
        sipAmount,
        ecsDate,
        xsipRegNo,
        mandateId:999,
        remark,
      });

      const result = response.data;
      if (result.StatusCode === 200) {
        Swal.fire("Success", result.message, "success");
      } else {
        Swal.fire("Error", result.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message ||
          "Something went wrong while processing your request.",
        "error"
      );
    }
  }

  const cleanSchemeName = (scheme) => {
  const patterns = [
    "- GROWTH",
    "- REGULAR PLAN",
    "- REGULAR PLAN GROWTH",
    "- REGULAR PLAN - GROWTH",
    "- REGULAR PLAN - GROWT",
    "- REG - GROWTH",
    "-GROWTH",
    "- growth",
    "- REGULAR GROWTH",
  ];

  // Case-insensitive cleaning
  let cleanedName = scheme;

  patterns.forEach((pattern) => {
    const regex = new RegExp(pattern.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "i"); // escape + ignore case
    cleanedName = cleanedName.replace(regex, ""); // remove pattern
  });

  return cleanedName.trim(); // trim for safety
};


  const extractFolioNumber = (folio) =>
    folio.includes("/") ? folio.split("/")[0] : folio;

  const stpStop = () => {};

  const householdTotalSIP = isSystmeticInvestmentData?.result3?.reduce((grandTotal, investor) => {
  const total = investor.sipdata?.reduce(
    (acc, sip) => acc + Number(sip.sip_amount || 0),
    0
  );
  return grandTotal + total;
}, 0);

  const householdTotalSTP = isSystmeticInvestmentData?.STPdata?.reduce((grandTotal, investor) => {
    const total = investor.stpdata?.reduce(
      (acc, stp) => acc + Number(stp.transfer_amount || 0),
    0
  );
  return grandTotal + total;
}, 0);

const formatOrdinalDate = (dateString) => {
  if (!dateString) return "";
  const day = new Date(dateString).getDate();

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return getOrdinal(day); 
};

  return (
    <div className="container">
      <div className="row pt-4 d-none d-md-block">
        {/* {isLoading ? (
          <div className=" custom-loading ">
            <img
              src="/assets/images/lodingGif.gif"
              alt="Loading"
              style={{ width: "100px", height: "100px" }}
            />
            <h5> Please Wait...</h5>
          </div>
        ) : ( */}
          <>
            <div className="col">
              <p className="fs-3 clrgreen ">Active SIP's</p>
            </div>
            <div className="row">
              <div className="col">
                <div className="scroll-container">
                  <table className="table">
                    <thead className="sticky-header">
                      <tr>
                      <th scope="col">
                          <p className="fs-14">Mode</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">Folio No.</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">Fund Name</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">SIP Amount</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">ECS Date</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">Bank Details</p>
                        </th>
                        <th scope="col">
                          <p className="fs-14">Action</p>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {isSystmeticInvestmentData?.result3?.map(
                        (investor, index) => {
                          const investorTotal = investor.sipdata.reduce(
                            (acc, sip) => acc + Number(sip.sip_amount || 0),
                            0
                          );
                        
                          return (
                          <>
                            <React.Fragment key={index}>
                              {/* Investor Name Row */}
                              <tr>
                                <th colSpan="6" scope="col">
                                  <p className="fs-14 fw-bold">
                                    {investor.name}
                                  </p>
                                  </th>
                                  <td></td>
                              </tr>

                              {/* SIP Data Rows */}
                              {investor.sipdata.map((sip, sipIndex) => (
                                <tr key={sip._id}>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {sip.type}
                                    </p>
                                  </td>
                                  <th scope="row">
                                    <p className="fs-14 fw-normal">
                                      {sip.folio_no}
                                    </p>
                                  </th>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {sip.fundname}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {formatRupees(sip.sip_amount)}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {/* {["CAMS", "KARVY"].includes(sip.source)
                                        ? formatOrdinalDate(sip.sip_enddate)
                                        : sip.source === "BSE"
                                        ? formatOrdinalDate(sip.sip_startdate)
                                        : ""} */}
                                        {sip?.sip_frequency=='MONTHLY'? formatOrdinalDate(sip.sip_startdate):sip?.sip_frequency ||formatOrdinalDate(sip.sip_startdate)} 
                                    </p>
                                  </td>


                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {(sip.sip_bank_name ||
                                        sip.sip_bank_account) &&
                                        sip.sip_bank_name +
                                          "(" +
                                          sip.sip_bank_account +
                                          ")"}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {sip.type === "Online" && !sip.aum_as_per_rta && (

                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          sipStop(
                                            roomId,
                                            sip._id,
                                            sip.folio_no,
                                            sip.product_code,
                                            sip.fundname,
                                            sip.sip_amount,
                                            sip.sip_startdate,
                                            sip.xsip_reg_no,
                                            sip.mandate_id
                                          )
                                        }
                                      >
                                        <img
                                          src="assets/images/StopCircle.png"
                                          alt="Stop Icon"
                                          style={{
                                            width: "16px",
                                            marginRight: "5px",
                                          }}
                                        />
                                        Stop
                                      </span>
                                       )} 
                                    </p>
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                            <tr className="clrlightgreen">
                              <td className="text-center" colSpan="6">
                                <p className="fs-14">
                                  <span className="fs-14 fw-normal">
                                    Total:
                                  </span>{" "}
                                    {formatRupees(investorTotal)}
                                </p>
                                </td>
                                <td></td>
                            </tr>
                          </>
                          )
                        }
                        )
                      }

                      {/* Summary Row */}
                      <tr className="clrlightgreen">
                          {
                            isSystmeticInvestmentData?.result3?.length > 0 &&
                            isSystmeticInvestmentData.result3.some(investor => investor.sipdata?.length > 0) ? (
                              <td className="text-center" colSpan="6">
                                <p className="fs-14">
                                  <span className="fs-14 fw-normal">Household Total</span>: {" "}
                                  {formatRupees(householdTotalSIP)}  
                                </p>
                              </td>
                            ) : (
                              <td className="text-center " colSpan="7">
                              <p className="fs-14 text-muted">No Data Found</p>
                            </td>
                            )
                          }
                          <td></td>
                        </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col mt-5">
              <p className="fs-3 clrgreen ">Active STP's</p>
            </div>
            <div className="row">
              <div className="col">
                <div className="scroll-container ">
                  <table className="table">
                    <thead className="sticky-header">
                      <tr>
                        <th>
                          <p className="fs-14">Folio #</p>
                        </th>
                        <th>
                          <p className="fs-14">From Fund Name</p>
                        </th>
                        <th>
                          <p className="fs-14">To Fund Name</p>
                        </th>
                        <th>
                          <p className="fs-14">STP Amount</p>
                        </th>
                        <th>
                          <p className="fs-14">Frequency</p>
                        </th>
                        <th>
                          <p className="fs-14">STP Date</p>
                        </th>
                        <th>
                          <p className="fs-14">Action</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isSystmeticInvestmentData?.STPdata?.map(
                        (investor, index) => {
                          const investorTotal = investor?.stpdata?.reduce(
                            (acc, stp) => acc + Number(stp.transfer_amount || 0),
                            0
                          );
                        
                          return (
                         
                          <>
                            <React.Fragment key={index}>
                              <tr>
                                <th colSpan="7">
                                  <p className="fs-14 fw-bold">
                                    {investor.name}
                                  </p>
                                </th>
                                <td></td>
                              </tr>

                              {investor.stpdata.map((stp, stpIndex) => (
                                <tr key={stp._id}>
                                  <th>
                                    <p className="fs-14 fw-normal">
                                      {extractFolioNumber(stp.folio_no)}
                                    </p>
                                  </th>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {cleanSchemeName(stp.from_scheme_name)}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {cleanSchemeName(stp.to_scheme_name)}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {formatRupees(stp.transfer_amount)}
                                    </p>
                                  </td>
                                  <td>
                                    <button className="fs-14 fw-normal clrlightgreen border-0">
                                      {stp.frequency_type}
                                    </button>
                                  </td>
                                  <td>
                                    <p className="fs-14 fw-normal">
                                      {stp.stp_start_date} – {stp.stp_end_date}
                                    </p>
                                  </td>
                                  <td>
                                    {stp.type === "Online" && !stp.aum_as_per_rta && (
                                    <p
                                      className={`fs-14 fw-normal clrred`}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src="assets/images/StopCircle.png"
                                        alt=""
                                        style={{
                                          width: "16px",
                                          marginRight: "5px",
                                        }}
                                        onClick={() =>
                                          stpStop(
                                            stp.clientId,
                                            stp.id,
                                            stp.client_code,
                                            stp.stp_registration_no,
                                            stp.from_scheme_name,
                                            stp.to_scheme_name,
                                            stp.stp_start_date,
                                            stp.stp_end_date,
                                            stp.frequency_type,
                                            stp.transfer_amount,
                                            stp.no_of_transfers.stp.folio_no
                                          )
                                        }
                                      />
                                      Stop
                                    </p>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                             <tr className="clrlightgreen">
                              <td className="text-center" colSpan="6">
                                <p className="fs-14">
                                  <span className="fs-14 fw-normal">
                                    Total:
                                  </span>{" "}
                                    {formatRupees(investorTotal)}
                                </p>
                                </td>
                                <td></td>
                            </tr>
                          </>
                        )
                        }
                      )}

                        <tr className="clrlightgreen">
                          {
                            isSystmeticInvestmentData?.STPdata?.length > 0 &&
                              isSystmeticInvestmentData?.STPdata?.some(investor => investor.stpdata?.length > 0) ? (
                              <td className="text-center" colSpan="7">
                                <p className="fs-14">
                                  <span className="fs-14 fw-normal">Household Total</span>: {" "}
                                  {formatRupees(householdTotalSTP)}  
                            
                                </p>
                              </td>
                            ) : (
                              <td className="text-center" colSpan="7">
                                <p className="fs-14 text-muted">No Data Found</p>
                              </td>
                            )
                          }
                          <td></td>

                        </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        {/* )} */}
      </div>

      {/* ================= MOBILE VIEW (SIP) ================= */}
      <div className="row d-block d-md-none">
        <div className="col">
          <p className="fs-3 clrgreen ">Active SIP's</p>
        </div>
        {isSystmeticInvestmentData?.result3?.map((investor, idx) => (
          <div key={idx}>
            {/* Investor Name */}
            <p className="fw-bold fs-5 mt-3">{investor.name}</p>

            {/* Loop SIPs */}
            {investor.sipdata.map((sip, sipIndex) => {
              const isOpen = openSipIndex === sip._id;

              return (
                <div
                  key={sip._id}
                  className="card shadow-sm p-2 mb-3"
                >
                  {/* ======= Header (Fund Name + Toggle) ======= */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => toggleSip(sip._id)}
                    style={{ cursor: "pointer" }}
                  >
                    <p className="fw-bold mb-0">{sip.fundname}</p>

                    {isOpen ? (
                      <CiSquareMinus className="fs-4 text-success" />
                    ) : (
                      <CiSquarePlus className="fs-4 text-success" />
                    )}
                  </div>

                  {/* ======= Body ======= */}
                  {isOpen && (
                    <div className="mt-2">
                      {[
                        { label: "Mode", value: sip.type },
                        { label: "Folio No", value: sip.folio_no },
                        { label: "SIP Amount", value: formatRupees(sip.sip_amount) },
                        {
                          label: "ECS Date",
                          value:  sip?.sip_frequency=='MONTHLY'? formatOrdinalDate(sip.sip_startdate):sip?.sip_frequency||formatOrdinalDate(sip.sip_startdate)
,
                                       
                        },
                        {
                          label: "Bank Details",
                          value:
                            sip.sip_bank_name &&
                            `${sip.sip_bank_name} (${sip.sip_bank_account})`,
                        },
                      ].map((row, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between border-bottom py-1"
                        >
                          <span className="fw-bold">{row.label}</span>
                          <span>{row.value}</span>
                        </div>
                      ))}

                      {/* STOP ACTION */}
                      {sip.type === "Online" && !sip.aum_as_per_rta && (
                        <div
                          className="d-flex justify-content-between border-bottom py-1"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            sipStop(
                              roomId,
                              sip._id,
                              sip.folio_no,
                              sip.product_code,
                              sip.fundname,
                              sip.sip_amount,
                              sip.sip_startdate,
                              sip.xsip_reg_no,
                              sip.mandate_id
                            )
                          }
                        >
                          <span className="fw-bold text-danger">Stop SIP</span>
                          <img
                            src="assets/images/StopCircle.png"
                            alt=""
                            style={{ width: "22px" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {/* Investor Total */}
            <div className="text-end fw-bold text-success mb-4">
              Total: {formatRupees(
                investor.sipdata.reduce(
                  (acc, sip) => acc + Number(sip.sip_amount || 0),
                  0
                )
              )}
            </div>
          </div>
        ))}

        {/* Household Total */}
        <p className="fw-bold text-center bg-light p-2 mt-3">
          Household Total: {formatRupees(householdTotalSIP)}
        </p>
      </div>

      {/* ================= MOBILE VIEW (STP) ================= */}
      <div className="row d-block d-md-none">
        <div className="col">
          <p className="fs-3 clrgreen ">Active STP's</p>
        </div>
        {isSystmeticInvestmentData?.STPdata?.map((investor, idx) => (
          <div key={idx}>
            {/* Investor Name */}
            <p className="fw-bold fs-5 mt-3">{investor.name}</p>

            {/* Loop STPs */}
            {investor.stpdata.map((stp) => {
              const isOpen = openStpIndex === stp._id;

              return (
                <div
                  key={stp._id}
                  className="card shadow-sm p-2 mb-3"
                >
                  {/* Header */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    onClick={() => toggleStp(stp._id)}
                    style={{ cursor: "pointer" }}
                  >
                    <p className="fw-bold mb-0">{cleanSchemeName(stp.from_scheme_name)}</p>

                    {isOpen ? (
                      <CiSquareMinus className="fs-4 text-success" />
                    ) : (
                      <CiSquarePlus className="fs-4 text-success" />
                    )}
                  </div>

                  {/* Body */}
                  {isOpen && (
                    <div className="mt-2">
                      {[
                        { label: "Folio", value: extractFolioNumber(stp.folio_no) },
                        {
                          label: "From Fund",
                          value: cleanSchemeName(stp.from_scheme_name),
                        },
                        {
                          label: "To Fund",
                          value: cleanSchemeName(stp.to_scheme_name),
                        },
                        {
                          label: "Amount",
                          value: formatRupees(stp.transfer_amount),
                        },
                        { label: "Frequency", value: stp.frequency_type },
                        {
                          label: "STP Date",
                          value: `${stp.stp_start_date} - ${stp.stp_end_date}`,
                        },
                      ].map((row, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between border-bottom py-1"
                        >
                          <span className="fw-bold">{row.label}</span>
                          <span>{row.value}</span>
                        </div>
                      ))}

                      {/* STOP Action */}
                      {stp.type === "Online" && !stp.aum_as_per_rta && (
                        <div
                          className="d-flex justify-content-between border-bottom py-1 text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            stpStop(
                              stp.clientId,
                              stp.id,
                              stp.client_code,
                              stp.stp_registration_no,
                              stp.from_scheme_name,
                              stp.to_scheme_name,
                              stp.stp_start_date,
                              stp.stp_end_date,
                              stp.frequency_type,
                              stp.transfer_amount,
                              stp.no_of_transfers.stp.folio_no
                            )
                          }
                        >
                          <span className="fw-bold">Stop STP</span>
                          <img
                            src="assets/images/StopCircle.png"
                            style={{ width: "22px" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {/* Investor Total */}
            <div className="text-end fw-bold text-success mb-4 ">
              Total: {formatRupees(
                investor.stpdata.reduce(
                  (acc, stp) => acc + Number(stp.transfer_amount || 0),
                  0
                )
              )}
            </div>
          </div>
        ))}

        {/* Household Total */}
        <p className="fw-bold text-center bg-light p-2 mt-3">
          Household Total: {formatRupees(householdTotalSTP)}
        </p>
      </div>


          
    </div>
  );
};

export default InvestmentsTable;
